import { useState } from 'react';

export function useId() {
  const [id] = useState(crypto.randomUUID());
  return id;
}
